// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2kDFG","header":"ClearentDisclaimer_header__jIL3V","inner":"ClearentDisclaimer_inner__3AT8b"};